/** Empty Autocomplete value means “use organisation time”. */
export const ORGANISATION_TIME_ZONE_VALUE = '';

const FALLBACK_IANA_TIME_ZONES = [
  'Africa/Johannesburg',
  'Africa/Nairobi',
  'America/New_York',
  'America/Toronto',
  'Asia/Kolkata',
  'Australia/Sydney',
  'Europe/Berlin',
  'Europe/London',
  'Europe/Paris',
  'Pacific/Auckland',
  'UTC',
];

export function listIanaTimeZones(): string[] {
  try {
    const supported = (
      Intl as unknown as { supportedValuesOf?: (key: string) => string[] }
    ).supportedValuesOf?.('timeZone');
    if (supported && supported.length > 0) {
      return supported;
    }
  } catch {
    // Older runtimes may not support supportedValuesOf
  }
  return [...FALLBACK_IANA_TIME_ZONES];
}

export function getDeviceIanaTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  } catch {
    return '';
  }
}
